/**
 * Conflito de dupla cobertura: a pessoa é titular e também dependente do cônjuge no mesmo
 * contrato. O RH resolve na própria linha: reter um dos papéis com o motivo abaixo, ou seguir
 * com os dois. "Só como dependente" (reter a inclusão de titular) é proibido para quem tem
 * dependentes próprios, para a família não ficar sem titular.
 */
export const MOTIVO_DUPLA_COBERTURA = "Dupla cobertura";

export type DuplaCobertura = { outroPapel: "employee" | "dependent"; dependentesProprios: number } | null;

type Linha = { type: string; duplaCobertura?: DuplaCobertura };

export function podeReterPorDuplaCobertura(linha: Linha): boolean {
  if (!linha.duplaCobertura) return false;
  if (linha.type === "Dependente") return true;
  return linha.duplaCobertura.dependentesProprios === 0;
}

export function avisoDuplaCobertura(linha: Linha): string | null {
  const conflito = linha.duplaCobertura;
  if (!conflito) return null;
  const seguir = "Para manter nos dois planos, siga normalmente.";
  if (linha.type === "Dependente") {
    return `Também é titular neste contrato. Para manter só como titular, retenha esta inclusão com o motivo ${MOTIVO_DUPLA_COBERTURA}. ${seguir}`;
  }
  if (podeReterPorDuplaCobertura(linha)) {
    return `Também é dependente de outro titular neste contrato. Para manter só como dependente, retenha esta inclusão com o motivo ${MOTIVO_DUPLA_COBERTURA}. ${seguir}`;
  }
  const n = conflito.dependentesProprios;
  return `Também é dependente de outro titular neste contrato. Tem ${n} ${n === 1 ? "dependente" : "dependentes"} neste contrato, então não pode ficar só como dependente. ${seguir}`;
}
